export default function capitalize(string) {
  return string.slice(0,1).toUpperCase() + string.slice(1)
}